export default __webpack_public_path__ + "static/media/webdev.9504d81e.jpg";